<script setup>
import {SITE_TAGLINE, THERAPIST_NAME} from "@/content/site";
</script>

<template>
  <header class="section">
    <h1 class="hero-title">{{ THERAPIST_NAME }}</h1>
    <p class="hero-subtitle">{{ SITE_TAGLINE }}</p>
  </header>
</template>

<style scoped>
.section {
  background: var(--page-bg-overlay);
  width: 100%;
  max-width: 100%;
  color: var(--color-cream);
}

.hero-title {
  font-family: var(--font-heading);
  font-size: var(--font-size-xxxl);
  font-weight: var(--font-weight-light);
  color: var(--color-cream);
  margin-top: var(--spacing-xl);
  margin-bottom: var(--spacing-xs);
  letter-spacing: var(--letter-spacing-widest);
  line-height: var(--line-height-tight);
}

.hero-subtitle {
  font-size: var(--font-size-xl);
  color: var(--color-cream);
  line-height: var(--line-height-compact);
  letter-spacing: var(--letter-spacing-wide);
  font-weight: var(--font-weight-light);
  opacity: 0.95;
  margin-bottom: var(--spacing-lg);
  text-align: center;
}

@media (max-width: 768px) {
  .hero-title {
    letter-spacing: var(--letter-spacing-wider);
  }

  .hero-subtitle {
    letter-spacing: var(--letter-spacing-normal);
  }
}
</style>
